import { render, staticRenderFns } from "./AddressAddress.vue?vue&type=template&id=f2a90c06"
import script from "./AddressAddress.vue?vue&type=script&lang=js"
export * from "./AddressAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports